import View from "./View";

class HistoryView extends View {
    _parentElement = document.querySelector(".history-list ul");
    _cleanElement = document.querySelector(".history-remove");
    _removeElement
    /**
     * 
     * @param {Function} handler to read and print all history list 
     */
    loadHistory(handler) {
        window.addEventListener('load', function () {
            handler();
        });

    }

    _generateMarkup() {
        return `${this._data.map(el => this._generateMarkupPreview(el)).join("")}`
    }

    removeItem(handler) {
        this._parentElement.addEventListener("click", function (e) {

            const current = e.target.closest(".remove_item");
            if (!current) return
            handler(current.getAttribute("id"))
        })
    }
    cleanHistory(handler) {
        this._cleanElement.addEventListener("click", () => {
            handler()
        })
    }
    _generateMarkupPreview(data) {

        return `
            <li class="history_preview"   aria-label="${data?.title}"  >
                <div class="history_preview__data" role="link" class="">
                    <h4 class="history_preview__title">${data?.title} </h4>
                    <div>
                        <time>${data?.createdTime}</time>
                        <span class="remove_item" title="Remove Item" role="button" aria-label="remove" id=${data?.id}><span aria-hidden="true">×</span></span>
                    </div>
                </div>
                
            </li>
            `
    }
}

export default new HistoryView();